import { Box } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ContractContext } from "../../Context/ContractContext";

function Paypal({
  orderId,
  newAdd,
  totalAmount,
  billing_address_info,
  shipping_address_info,
  shipping,
  orderItems,
  shippingNew,
  taxAmount
}) {
  const { discountValue = 0, code, discount,setDiscountValue,setDiscountType,setCode } = useContext(ContractContext);
  const [paypalContainer, setPaypalContainer] = useState(null);
  const navigate = useNavigate();

  // Calculate totals
  const itemTotal = orderItems.reduce((acc, item) => {
    return acc + parseFloat(item.productData[0].price) * item.quantity;
  }, 0);

  const shippingFee = shipping ? parseFloat(shipping) : 0;
  const discountAmount = discountValue > 0 ? parseFloat(discountValue) : 0;
  const grandTotal = (
  itemTotal +
  shippingFee -
  discountAmount
).toFixed(2);

  // Construct PayPal Purchase Unit
  const _purchase_units = [
    {
      amount: {
        currency_code: "USD",
        value: grandTotal,
        breakdown: {
          item_total: {
            currency_code: "USD",
            value: itemTotal.toFixed(2),
          },
          shipping: {
            currency_code: "USD",
            value: shippingFee.toFixed(2),
          },
        //      tax_total: {
        //   currency_code: "USD",
        //   value: parseFloat(taxAmount || 0).toFixed(2),
        // },
          discount: {
            currency_code: "USD",
            value: discountAmount.toFixed(2),
          },
          
        },
      },
      items: orderItems.map((e) => ({
        name: e.productData[0].name,
        description: e.productData[0].name,
        unit_amount: {
          currency_code: "USD",
          value: parseFloat(e.productData[0].price).toFixed(2),
        },
        
        quantity: e.quantity.toString(),
      })),
      shipping: {
        name: {
          full_name:
            newAdd === false
              ? billing_address_info?.fname
              : shipping_address_info?.fname,
        },
        address: {
          address_line_1:
            newAdd === false
              ? billing_address_info?.address_1
              : shipping_address_info?.address_1,
          address_line_2:
            newAdd === false
              ? billing_address_info?.address_2
              : shipping_address_info?.address_2,
          admin_area_2:
            newAdd === false
              ? billing_address_info?.city
              : shipping_address_info?.city,
          admin_area_1:
            newAdd === false
              ? billing_address_info?.state
              : shipping_address_info?.state,
          postal_code:
            newAdd === false
              ? billing_address_info?.postal
              : shipping_address_info?.postal,
          country_code:
            newAdd === false
              ? billing_address_info?.country
              : shipping_address_info?.country,
        },
      },
    },
  ];

  useEffect(() => {
    if (!paypalContainer) {
      console.error("PayPal container not found");
      return;
    }

    window.paypal
      .Buttons({
        createOrder: (data, actions, err) => {
          return actions.order.create({
            purchase_units: _purchase_units,
          });
        },
        onApprove: async (data, actions) => {
          return actions.order.capture().then(function (details) {
            console.log(details);
            confirmOrder(orderId, details);
          });
        },
        onError: (err) => {
          console.error("PayPal Error:", err);
        },
      })
      .render(paypalContainer);
    // eslint-disable-next-line
  }, [paypalContainer]);

  const confirmOrder = async (id, details) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/shopping-cart/confirm-order`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            order_id: id,
            transaction_body: JSON.stringify(details),
            transaction_id: details.id,
            shipping_method: shippingNew,
            discountCode: code,
            discount: discountValue,
            taxAmount: taxAmount,
          }),
        }
      );

      const data = await response.json();
      if (data.status) {
        navigate(`/view-order/${id}`);
          setDiscountValue(0);
                setCode("")
                setDiscountType("")
              
      } else {
        alert("Something went wrong..");
      }
    } catch (error) {
      console.error("Order confirmation error:", error);
      alert("Something went wrong..");
    }
  };

  return (
    <Box mt={"1rem"}>
      <div
        data-pp-message
        data-pp-style-layout="text"
        data-pp-style-logo-type="inline"
        data-pp-style-text-color="black"
        data-pp-style-text-size="16"
        data-pp-amount={grandTotal}
        data-pp-placement="payment"
      ></div>
      <div ref={setPaypalContainer}></div>
    </Box>
  );
}

export default Paypal;
